import React from 'react';
import { Frame, SageClassnames, useSageBreakpoint, Icon } from '@kajabi/sage-react';

import { useCheckout } from '../../context';

const CheckCircleIcon = () => (
  <Icon
    color="primary-300"
    icon="check-circle-filled"
    label="Click me"
    size="md"
    style={{ marginRight: '10px' }}
  />
);

export const SignupInfo = () => {
  const breakpoints = useSageBreakpoint();
  const {
    planInfo: { signup_info: signupInfo },
    minified,
  } = useCheckout();

  if (minified) return null;

  return (
    <Frame style={{ width: breakpoints.sm ? '100%' : '50%' }}>
      <h2 className="marketing-signup__title">{signupInfo.header}</h2>
      <ul className="marketing-signup__features">
        {signupInfo.bullet_points.map((item, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <li key={`signup_features_${index}`} className="marketing-signup__feature">
            <CheckCircleIcon />
            {item}
          </li>
        ))}
      </ul>
      {signupInfo.footnote && (
        <p className={SageClassnames.TYPE_COLORS.CHARCOAL_300}>{signupInfo.footnote}</p>
      )}
      <img alt="Signup Info" src={signupInfo.image_url} style={{ maxWidth: '100%' }} />
    </Frame>
  );
};
